import image01 from "@/public/mock_images/image_14.webp";
import image02 from "@/public/mock_images/image_09.webp";
import image03 from "@/public/mock_images/image_10.webp";
import image04 from "@/public/mock_images/image_06.webp";
import image12 from "@/public/mock_images/image_12.webp";
import image13 from "@/public/mock_images/image_13.webp";
import building from "@/public/mock_images/image_07.webp";

export const DRAWER_ROUTES = [
  {
    label: "Početna",
    href: "/",
    image: image01,
  },
  {
    label: "O nama",
    href: "/o-nama",
    image: image02,
  },
  {
    label: "Usluge",
    href: "/usluge",
    image: building,
  },
  {
    label: "Galerija",
    href: "/galerija",
    image: image12,
  },
  {
    label: "Pacijenti",
    href: "/pacijenti",
    image: image13,
  },
  {
    label: "Ordinacija",
    href: "/ordinacija",
    image: image03,
  },
  {
    label: "Kontakt",
    href: "/kontakt",
    image: image04,
  },
];
